import {
  ACTIVE_PATIENTS_FAILURE,
  ACTIVE_PATIENTS_REQUEST,
  ACTIVE_PATIENTS_SUCCESS,
  SHIFT_ACTIVE_PATIENTS_LIST,
} from "../actions/actionTypes";

const initialState = {
  activePatientList: [],
  isFetchingActivePatientList: false,
  isErrorInActivePatientList: null,
};

const activePatients = (state, action) => {
  if (typeof state === "undefined") {
    return initialState;
  } else {
    switch (action.type) {
      case ACTIVE_PATIENTS_REQUEST:
        return {
          ...state,
          isFetchingActivePatientList: true,
          isErrorInActivePatientList: null,
        };
      case ACTIVE_PATIENTS_SUCCESS:
        return {
          ...state,
          isFetchingActivePatientList: false,
          activePatientList: action.payload,
          isErrorInActivePatientList: null,
        };
      case ACTIVE_PATIENTS_FAILURE:
        return {
          ...state,
          isFetchingActivePatientList: false,
          isErrorInActivePatientList: "SomeThing went wrong.",
        };
      case SHIFT_ACTIVE_PATIENTS_LIST:
        return {
          ...state,
          isFetchingActivePatientList: false,
          activePatientList: action.payload,
        };
      default:
        return state;
    }
  }
};

export default activePatients;
